const CHUNK_RELOAD_KEY = 'econtractor-chunk-reload';

const CHUNK_ERROR_PATTERN =
    /ChunkLoadError|Loading chunk [\w.-]+ failed|Failed to fetch dynamically imported module|Importing a module script failed/i;

function errorText(error: unknown): string {
    if (typeof error === 'string') return error;
    if (error instanceof Error) return `${error.name} ${error.message}`;
    if (error && typeof error === 'object') {
        const record = error as { name?: unknown; message?: unknown };
        return `${String(record.name ?? '')} ${String(record.message ?? '')}`;
    }
    return '';
}

export function isChunkLoadError(error: unknown): boolean {
    return CHUNK_ERROR_PATTERN.test(errorText(error));
}

function hasReloadFlag(): boolean {
    try {
        return sessionStorage.getItem(CHUNK_RELOAD_KEY) === '1';
    } catch {
        return false;
    }
}

function setReloadFlag(): void {
    try {
        sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
    } catch {
        // sessionStorage недоступний — reload все одно один, бо сторінка перезавантажиться
    }
}

export function reloadOnceOnChunkError(): void {
    if (hasReloadFlag()) return;
    setReloadFlag();
    window.location.reload();
}

export function installChunkReload(): void {
    window.setTimeout(() => {
        try {
            sessionStorage.removeItem(CHUNK_RELOAD_KEY);
        } catch {
            // ignore
        }
    }, 10000);

    window.addEventListener('error', (event) => {
        if (isChunkLoadError(event.error) || isChunkLoadError(event.message)) {
            reloadOnceOnChunkError();
        }
    });

    window.addEventListener('unhandledrejection', (event) => {
        if (isChunkLoadError(event.reason)) {
            reloadOnceOnChunkError();
        }
    });
}
